import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SxSecurityService } from '../infrastructure/services/sxSecurity.service';
import { AlertService } from '../infrastructure/services/alert.service';
import { RememberMeService } from '../infrastructure/services/rememberme.service';
import { SxContextService } from '../infrastructure/services/sxContext.service';
import { SxTranslationService } from 'app/infrastructure/services/translation-service.service';

@Component({
  selector: 'login-soc',
  templateUrl: './login.component.html'
})
export class LoginComponent implements OnInit {
  esperandoRespuesta = false;
  rememberMe = false;
  email: string;
  password: string;
  lang: string;
  rol: string;
  errors = {
    email: null,
    password: null,
    server: null,
  };
  languages: any;
  languageSelected: string;
  persistLanguage = false;

  constructor(private router: Router,
              private sxSecurity: SxSecurityService,
              private sxContextService: SxContextService,
              private sxTranslationService: SxTranslationService,
              private rememberMeService: RememberMeService,
              private sxAlert: AlertService) { }

  ngOnInit(): void {
    // Si el usuario ya esta logueado, proceder hacia la Home
    this.sxSecurity.isLoggedIn().then(resLogin => 
      {
        if(resLogin)
        { 

      // Si tengo un sistema por defecto, redirecciono directamente a la home
      if (this.sxContextService.existeContexto()) {
        this.router.navigate(['/soc', this.sxContextService.getContexto()]);
        return;
      }

      this.router.navigate(['/soc']);
      return;
    }
  });

    // Si Recordarme fue seleccionado anteriormente
    // this.rememberMe = this.rememberMeService.isRememberMeActive();
    // if (this.rememberMe) {
    //   const credencialesGuardadas = this.rememberMeService.get();
    //   this.email = credencialesGuardadas.username;
    //   this.password = credencialesGuardadas.password;
    // } 
    this.sxTranslationService.getAllLanguages()
      .then(res => {
        if (!res.error) {
          this.languages = res.result;
          var lan = this.sxTranslationService.getSelectedLanguage();
          this.sxTranslationService.setServerLanguage(lan);
          if (this.languages.find(x => x.culture === lan))
            this.languageSelected = lan;
          else
            this.languageSelected = lan.split('-')[0];
        }
        else {
          console.log(res.error);
          this.mostrarErrorDelServer(res.error);
        }
      });
  }

  onChangeLanguage() {
    this.sxTranslationService.setLanguage(this.languageSelected);
    this.sxTranslationService.setServerLanguage(this.languageSelected);
    window.location.reload();
  }

  ingresar() {
    if (!this.credencialesValidas()) {
      return;
    }

    // sets the language string
    if (this.persistLanguage)
      this.lang = this.languageSelected;
    else
      this.lang = window.navigator.language;

    this.esperandoRespuesta = true;
    this.sxSecurity.login(this.email, this.password, this.lang, this.rol, this.rememberMe, this.persistLanguage)
      .then(() => {
        this.esperandoRespuesta = false;
        // this.manejarRememberMe();

        // Si tengo un sistema por defecto, redirecciono directamente a la home
        if (this.sxContextService.existeContexto()) {
          this.router.navigate(['/soc', this.sxContextService.getContexto()]);
          return;
        }

        this.router.navigate(['/soc']);
      })
      .catch(err => {
        this.esperandoRespuesta = false;
        this.mostrarErrorDelServer(err);
      });
  }

  private credencialesValidas() {
    this.resetearErrores();
    let esValido = true;

    if (!this.email || this.email.length === 0) {
      this.errors.email = 'USUARIO_VACIO';
      esValido = false;
    }

    if (!this.password || this.password.length === 0) {
      this.errors.password = 'CONTRASEÑA_VACIA';
      esValido = false;
    }

    return esValido;
  }

  private resetearErrores() {
    this.errors = {
      email: null,
      password: null,
      server: null,
    };
  }

  private mostrarErrorDelServer(err) {
    if (err.errors && err.errors[0]) {
      this.errors.server = err.errors[0].errorMessage;
    }
  }

  /**
   * Si Recordarme esta checkeado entonces
   * guardamos las credenciales en LocalStorage,
   * sino, no las guardamos y removemos la existente
   */
  // private manejarRememberMe() {
  //   if (this.rememberMe) {
  //     this.rememberMeService.set({
  //       username: this.email,
  //       password: this.password,
  //     });
  //     return;
  //   }

  //   this.rememberMeService.remove();
  // }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/public/login.component.ts